export const API_URL = import.meta.env.VITE_API_URL || "http://localhost:8789";
export const ADMIN_API_URL = `${API_URL}/admin`;
export const APP_URL = import.meta.env.VITE_APP_URL || "http://localhost:3000";
